import { type PropsWithChildren, createContext, useRef } from "react";
import type { Context as ContextType } from "./types";

export const Context = createContext<ContextType>(null);

export default function RootElement({
	children,
	root,
}: PropsWithChildren<{ root: ContextType }>) {
	const __root = useRef<Element>(null);

	if (!__root.current) {
		__root.current = root;
	}
	return <Context value={__root.current}>{children}</Context>;
}
